import type { ReactElement, SVGProps } from 'react';

type IconProps = SVGProps<SVGSVGElement> & { size?: number };

function base({ size = 20, ...rest }: IconProps) {
  return {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    'aria-hidden': true as const,
    ...rest,
  };
}

export function IconHome(p: IconProps) {
  return (
    <svg {...base(p)}>
      <path d="M3 10.5 12 3l9 7.5" />
      <path d="M5 10v10h14V10" />
    </svg>
  );
}
export function IconWallet(p: IconProps) {
  return (
    <svg {...base(p)}>
      <path d="M3 7h18v12H3z" />
      <path d="M3 7V5h18" />
      <path d="M16 13h2" />
    </svg>
  );
}
export function IconBill(p: IconProps) {
  return (
    <svg {...base(p)}>
      <path d="M7 3h10v18H7z" />
      <path d="M10 8h4M10 12h4M10 16h3" />
    </svg>
  );
}
export function IconGame(p: IconProps) {
  return (
    <svg {...base(p)}>
      <path d="M6 10h12a4 4 0 0 1 0 8H6a4 4 0 0 1 0-8z" />
      <path d="M9 14h2M10 13v2M15.5 13.5h.01M17 15h.01" />
    </svg>
  );
}
export function IconOrders(p: IconProps) {
  return (
    <svg {...base(p)}>
      <path d="M8 6h13M8 12h13M8 18h13" />
      <path d="M3 6h.01M3 12h.01M3 18h.01" />
    </svg>
  );
}
export function IconMore(p: IconProps) {
  return (
    <svg {...base(p)}>
      <path d="M4 7h16M4 12h16M4 17h16" />
    </svg>
  );
}
export function IconUsers(p: IconProps) {
  return (
    <svg {...base(p)}>
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="3" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a3 3 0 0 1 0 5.74" />
    </svg>
  );
}
export function IconDeposit(p: IconProps) {
  return (
    <svg {...base(p)}>
      <path d="M12 3v12" />
      <path d="m7 10 5 5 5-5" />
      <path d="M5 21h14" />
    </svg>
  );
}
export function IconSettings(p: IconProps) {
  return (
    <svg {...base(p)}>
      <circle cx="12" cy="12" r="3" />
      <path d="M19 12a7 7 0 0 0-.2-1.6l2-1.2-2-3.4-2.3.7a7.2 7.2 0 0 0-2.8-1.6L13 2h-2l-.7 2.9a7.2 7.2 0 0 0-2.8 1.6L5.2 5.8l-2 3.4 2 1.2A7 7 0 0 0 5 12c0 .5.1 1.1.2 1.6l-2 1.2 2 3.4 2.3-.7a7.2 7.2 0 0 0 2.8 1.6L11 22h2l.7-2.9a7.2 7.2 0 0 0 2.8-1.6l2.3.7 2-3.4-2-1.2c.1-.5.2-1.1.2-1.6z" />
    </svg>
  );
}
export function IconShield(p: IconProps) {
  return (
    <svg {...base(p)}>
      <path d="M12 3 4 6v6c0 5 3.5 8 8 9 4.5-1 8-4 8-9V6l-8-3z" />
    </svg>
  );
}
export function IconSupport(p: IconProps) {
  return (
    <svg {...base(p)}>
      <path d="M12 21a9 9 0 1 0-9-9" />
      <path d="M8 14h.01M12 14h.01M16 14h.01" />
      <path d="M3 21v-6h4" />
    </svg>
  );
}
export function IconBell(p: IconProps) {
  return (
    <svg {...base(p)}>
      <path d="M6 9a6 6 0 1 1 12 0c0 7 3 7 3 7H3s3 0 3-7" />
      <path d="M10 21h4" />
    </svg>
  );
}
export function IconUser(p: IconProps) {
  return (
    <svg {...base(p)}>
      <circle cx="12" cy="8" r="3.5" />
      <path d="M5 20a7 7 0 0 1 14 0" />
    </svg>
  );
}
export function IconLogout(p: IconProps) {
  return (
    <svg {...base(p)}>
      <path d="M10 17v1a2 2 0 0 0 2 2h7V4h-7a2 2 0 0 0-2 2v1" />
      <path d="M15 12H3m0 0 3-3M3 12l3 3" />
    </svg>
  );
}
export function IconClose(p: IconProps) {
  return (
    <svg {...base(p)}>
      <path d="M6 6l12 12M18 6 6 18" />
    </svg>
  );
}
export function IconDevice(p: IconProps) {
  return (
    <svg {...base(p)}>
      <rect x="6" y="3" width="12" height="18" rx="2" />
      <path d="M11 17h2" />
    </svg>
  );
}
export function IconChart(p: IconProps) {
  return (
    <svg {...base(p)}>
      <path d="M4 19h16" />
      <path d="M7 16V9M12 16V5M17 16v-6" />
    </svg>
  );
}
export function IconCopy(p: IconProps) {
  return (
    <svg {...base(p)}>
      <rect x="8" y="8" width="12" height="12" rx="2" />
      <path d="M4 16V6a2 2 0 0 1 2-2h10" />
    </svg>
  );
}
export function IconZap(p: IconProps) {
  return (
    <svg {...base(p)}>
      <path d="M13 2 4 14h7l-1 8 9-12h-7l1-8z" />
    </svg>
  );
}
export function IconPackage(p: IconProps) {
  return (
    <svg {...base(p)}>
      <path d="M3 8 12 3l9 5v11l-9 5-9-5V8z" />
      <path d="M12 13v8M3 8l9 5 9-5" />
    </svg>
  );
}
export function IconSearch(p: IconProps) {
  return (
    <svg {...base(p)}>
      <circle cx="11" cy="11" r="7" />
      <path d="m20 20-3.5-3.5" />
    </svg>
  );
}
export function IconRefresh(p: IconProps) {
  return (
    <svg {...base(p)}>
      <path d="M21 12a9 9 0 1 1-2.6-6.2" />
      <path d="M21 3v6h-6" />
    </svg>
  );
}
export function IconEdit(p: IconProps) {
  return (
    <svg {...base(p)}>
      <path d="M12 20h9" />
      <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" />
    </svg>
  );
}
export function IconLock(p: IconProps) {
  return (
    <svg {...base(p)}>
      <rect x="5" y="11" width="14" height="10" rx="2" />
      <path d="M8 11V8a4 4 0 0 1 8 0v3" />
    </svg>
  );
}
export function IconCheck(p: IconProps) {
  return (
    <svg {...base(p)}>
      <path d="M20 6 9 17l-5-5" />
    </svg>
  );
}

export type IconName =
  | 'home'
  | 'wallet'
  | 'bill'
  | 'game'
  | 'orders'
  | 'more'
  | 'users'
  | 'deposit'
  | 'settings'
  | 'shield'
  | 'support'
  | 'bell'
  | 'user'
  | 'logout'
  | 'close'
  | 'device'
  | 'chart'
  | 'copy'
  | 'zap'
  | 'package'
  | 'search'
  | 'refresh'
  | 'edit'
  | 'lock'
  | 'check';

const MAP: Record<IconName, (p: IconProps) => ReactElement> = {
  home: IconHome,
  wallet: IconWallet,
  bill: IconBill,
  game: IconGame,
  orders: IconOrders,
  more: IconMore,
  users: IconUsers,
  deposit: IconDeposit,
  settings: IconSettings,
  shield: IconShield,
  support: IconSupport,
  bell: IconBell,
  user: IconUser,
  logout: IconLogout,
  close: IconClose,
  device: IconDevice,
  chart: IconChart,
  copy: IconCopy,
  zap: IconZap,
  package: IconPackage,
  search: IconSearch,
  refresh: IconRefresh,
  edit: IconEdit,
  lock: IconLock,
  check: IconCheck,
};

export function Icon({ name, ...rest }: IconProps & { name: IconName }) {
  const Comp = MAP[name];
  return <Comp {...rest} />;
}
